import store from "@/config/vuex/store";

export default [
    {
        path: "/relatorios",
        component: () => import('@/pages/Layout/DashboardLayout'),
        children: [
            {
                path: "/",
                name: "relatoriosView",
                component: () => import('@/pages/Relatorio/RelatorioView'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
        ]
    }
]

